import React from 'react';
import { Box, Typography } from '@mui/material';
import { Images } from '../../../utils/Images';

const WhyChooseUsCard = ({ 
  icon, 
  title, 
  description,
  isMobile = false,
  isMediumScreen = false,
  isTablet = false,
  isDesktop = false
}) => {
  // Responsive styles function
  const getResponsiveStyles = () => {
    if (isMobile) {
      return {
        card: {
          width: '280px',
          height: '172px',
          borderRadius: '16px',
          paddingTop: '20px',
          paddingRight: '20px',
          paddingBottom: '20px',
          paddingLeft: '20px',
          gap: '8px'
        },
        icon: {
          width: '32px',
          height: '32px',
          borderRadius: '10px',
          padding: '6px'
        },
        iconSize: {
          width: '20px',
          height: '20px'
        },
        title: {
          fontSize: '14px',
          lineHeight: '100%'
        },
        description: {
          fontSize: '13px',
          lineHeight: '18px'
        }
      };
    } else if (isMediumScreen) {
      return {
        card: {
          width: '320px',
          borderRadius: '18px',
          paddingTop: '24px',
          paddingRight: '24px',
          paddingBottom: '24px',
          paddingLeft: '24px',
          gap: '9px'
        },
        icon: {
          width: '36px',
          height: '36px',
          borderRadius: '12px',
          padding: '7px'
        },
        iconSize: {
          width: '22px',
          height: '22px'
        },
        title: {
          fontSize: '14px',
          lineHeight: '100%'
        },
        description: {
          fontSize: '12px',
          lineHeight: '20px'
        }
      };
    } else if (isTablet) {
      return {
        card: {
          width: '380px',
          height: '250px',
          borderRadius: '20px',
          paddingTop: '28px',
          paddingRight: '28px',
          paddingBottom: '28px',
          paddingLeft: '28px',
          gap: '9px'
        },
        icon: {
          width: '38px',
          height: '38px',
          borderRadius: '12.5px',
          padding: '7.5px'
        },
        iconSize: {
          width: '23px',
          height: '23px'
        },
        title: {
          fontSize: '15px',
          lineHeight: '100%'
        },
        description: {
          fontSize: '15px',
          lineHeight: '22px'
        }
      };
    } else {
      return {
        card: {
          width: '426px',
          height: '233px',
          borderRadius: '24px',
          paddingTop: '32px',
          paddingRight: '31px',
          paddingBottom: '32px',
          paddingLeft: '31px',
          gap: '10px'
        },
        icon: {
          width: '40px',
          height: '40px',
          borderRadius: '13.33px',
          padding: '8px'
        },
        iconSize: {
          width: '24px',
          height: '24px'
        },
        title: {
          fontSize: '16px',
          lineHeight: '100%'
        },
        description: {
          fontSize: '16px',
          lineHeight: '24px'
        }
      };
    }
  };

  const styles = getResponsiveStyles();

  return (
    <Box
      sx={{
        width: styles.card.width,
        '@media (min-width: 1440px)': {
          width: '465px',
        },
        height: styles.card.height,
        borderRadius: styles.card.borderRadius,
        paddingTop: styles.card.paddingTop,
        paddingRight: styles.card.paddingRight,
        paddingBottom: styles.card.paddingBottom,
        paddingLeft: styles.card.paddingLeft,
        background: '#F2F3F4CC',
        display: 'flex',
        flexDirection: 'column',
        gap: styles.card.gap
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: styles.icon.width,
          height: styles.icon.height,
          borderRadius: styles.icon.borderRadius,
          padding: styles.icon.padding,
          background: '#A9C74E',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img
          src={Images[icon]}
          alt={title}
          style={{
            width: styles.iconSize.width,
            height: styles.iconSize.height,
            objectFit: 'contain'
          }}
        />
      </Box>

      {/* Title */}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: styles.title.fontSize,
          lineHeight: styles.title.lineHeight,
          letterSpacing: '0%',
          color: '#1D1D1B'
        }}
      >
        {title}
      </Typography>

      {/* Description */}
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: styles.description.fontSize,
          lineHeight: styles.description.lineHeight,
          letterSpacing: '0%',
          verticalAlign: 'middle',
          color: '#7D7D7D'
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

// // Data for all 6 cards
// const whyChooseUsData = [
//   {
//     id: 1,
//     icon: 'WCUclock',
//     title: 'Long Term - Impact',
//     description: 'Your contributions go beyond immediate relief, creating sustainable programs that transform lives over time.'
//   },
//   {
//     id: 2,
//     icon: 'WCUheart',
//     title: 'Transparent Impact',
//     description: 'We maintain complete transparency, ensuring every rupee is spent effectively. You\'ll always know exactly how your support.'
//   },
//   {
//     id: 3,
//     icon: 'WCUcalendar',
//     title: 'Monthly Updates',
//     description: 'Get regular updates on the children and communities you support, seeing your generosity come to life every month.'
//   },
//   {
//     id: 4,
//     icon: 'WCUmoney',
//     title: 'Avail Tax Benefits',
//     description: 'Your kindness not only changes lives but also offers you tax benefits. Giving back becomes even more rewarding with financial relief'
//   },
//   {
//     id: 5,
//     icon: 'WCUhappyemoji',
//     title: 'Spread Smiles every month',
//     description: 'Consistent support from you means consistent care for those in need. Every month, your donations bring hope and happiness'
//   },
//   {
//     id: 6,
//     icon: 'WCUverify',
//     title: 'Rewards',
//     description: 'We celebrate your generosity with recognition and rewards. Each contribution is a step toward a world where your kindness.'
//   }
// ];

export default WhyChooseUsCard;
// export { whyChooseUsData };
